const page_param = "f_page";

jQuery(function($) { $('#instagram').load('https://sf.appsbyba.com/instagram/feed/art-shed-brisbane.myshopify.com') });

$(document).ready(function(){
  console.log('document ready');
  //applyFilterOption();
  
  
});

$(function(){
  if( $('.filter-active').length > 0 && location.search.indexOf('_=pf') == -1 ){
    console.log("appended _=pf");
    var newURL = updateURLParameter(location.href, '_', 'pf');
    if (window.history.replaceState) {
      //prevents browser from storing history with each change:
      window.history.replaceState(null, null, newURL);
    }
  }
});

function initFauxProductPage(){
  sortByHexCodes();
  setupCollectionProductPagination();
}


function updateURLParameter(url, param, paramVal)
{
  var TheAnchor = null;
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";

  if (additionalURL) 
  {
    var tmpAnchor = additionalURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if(TheAnchor)
      additionalURL = TheParams;

    tempArray = additionalURL.split("&");

    for (var i=0; i<tempArray.length; i++)
    {
      if(tempArray[i].split('=')[0] != param)
      {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }        
  }
  else
  {
    var tmpAnchor = baseURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor  = tmpAnchor[1];

    if(TheParams)
      baseURL = TheParams;
  }

  if(TheAnchor)
    paramVal += "#" + TheAnchor;

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
}



function setFauxProductCurrentPage(page){  
  var url=window.location.href,
      separator = (url.indexOf("?")===-1)?"?":"&",
      newParam= page_param + "=" + page,
      formattedParam = separator + newParam;

  if(url.indexOf(newParam) != -1){
    //return;
  }

  //newUrl=url.replace(newParam,"");
  //newUrl+=newParam;
  //window.location.href =newUrl; MAKES PAGE RELOAD

  var newUrl = updateURLParameter(url, page_param, page)
  window.history.pushState(null, null, newUrl);

}

function getFauxProductCurrentPage(numPages) {
  var vars = {};
  var f_page = 1;
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
    vars[key] = value;
  });

  if(vars.hasOwnProperty(page_param)){
    f_page = vars[page_param];
    if(f_page > numPages){
      f_page = 1;
    }
  }
  return f_page;
}

function setupCollectionProductPagination(){
  var productList = $("#collection-template-over-100-variants .product-list");
  var products = productList.find(".product-item");
  var productsPerPage = 50;
  var numPages = Math.ceil(products.length / productsPerPage);
  var currentPage = getFauxProductCurrentPage(numPages); // TODO make this value be set from URL params



  if(numPages > 1){
    for(var i = 1; i <= numPages; i++){
      var activeString = (currentPage == i ? " is-active " : "");
      $('.pagination__nav').append('<span data-index-start="' + (i - 1)*productsPerPage + '" data-index-end="' + (i)*productsPerPage + '" data-page="' + i + '" class="pagination__nav-item' +activeString + '">' + i + '</span>');
    }
  }

  // Nav number Clicked
  $('body #collection-template-over-100-variants').on('click', '.pagination__nav-item', function(e){
    e.preventDefault();
    goToPage($(this).data('page'), productsPerPage, true);
  });

  // Previous Page
  $('.pagination__prev-1').on('click', function(e){
    e.preventDefault();
    console.log("Prev");
    var pageNum = $('.is-active').prev().data('page');
    if(typeof pageNum !== undefined && pageNum >= 1){
      goToPage(pageNum, productsPerPage, true);
    }
  });
  // Next Page
  $('.pagination__next-1').on('click', function(e){
    e.preventDefault();
    console.log("Next");
    var pageNum = $('.is-active').next().data('page');
    if(typeof pageNum !== undefined && pageNum <= numPages){
      goToPage(pageNum, productsPerPage, true);
    }
  });  

  goToPage(currentPage, productsPerPage, false);

}


function goToPage(page, numProductsPerPage, animate){
  var productList = $("#collection-template-over-100-variants .product-list");
  var products = productList.find(".product-item");
  var productsToShow = products.slice((page - 1) * (numProductsPerPage), (page) * (numProductsPerPage));

  $('.pagination__nav-item.is-active').removeClass("is-active");
  $('.pagination__nav-item[data-page="' + page + '"]').addClass("is-active");

  if(animate){
    products.fadeOut().promise().done(function(){
      productsToShow.fadeIn();
    });
  } else{
    products.hide();
    productsToShow.show(); 
  }
  document.body.scrollIntoView({behavior: 'smooth', block: 'start'});

  setFauxProductCurrentPage(page);
}

// Hex Sorting Start

function  sortByHexCodes(){
  var productItems = $('#collection-template-over-100-variants .product-list .product-item').map( function( i, element ) {
    return {
      'name': $(this).data('name'), 
      'rgb-json': $(this).data('colour-rgb-json'), 
      'rgb-key': $(this).data('colour-rgb-vals-only'), 
      'rgb': $(this).data('colour-rgb'),    
      'rgb-vals-only': $(this).data('colour-rgb-vals-only'),    
      'hex': $(this).data('colour-hex'),    
      //'hsl': $(this).data('colour-hsl'),
      'elem': $(this),
      'html': $(this).html(),
      'value': $(this).data('colour-hex')

    }
  });
  //var sC = sortColors(productItems);

  var sortedColours = sortColorsByHue(productItems);
  console.log("sortedColours");
  console.log(sortedColours);
  if(sortedColours != undefined){
    /*var mappedElems = sC.map( function( item, index ) {
      return $(item.hsl.elem)[0];
    });*/ 
    $('#collection-template-over-100-variants .product-list .product-item').remove();
    console.log("final color count");
    console.log(sortedColours.length);
    $(sortedColours).each(function(){
      var t = $(this)[0];

      $('#collection-template-over-100-variants .product-list').append(t.hsl.elem.elem);
    });
  }
  $('#collection-template-over-100-variants .product-list').removeClass("hide-until-js");
  //return c;
}

function sortColors(colors) {
  console.log("Colors: ");
  console.log(colors);
  // Calculate distance between each color
  // Temp
  var con = 0; 
  var nCon = 0;

  var distances = [];
  for (var i = 0; i < colors.length; i++) {
    distances[i] = [];
    for (var j = 0; j < i; j++){
      distances.push([colors[i], colors[j], colorDistance(colors[i]['rgb-json'], colors[j]['rgb-json'])]);
    }
  }

  distances.sort(function(a, b) {
    return a[2] - b[2];
  });
  console.log("Distances: ");
  console.log(distances);
  // Put each color into separate cluster initially
  var colorToCluster = {};
  for (var i = 0; i < colors.length; i++)
    if(colorToCluster.hasOwnProperty(colors[i]['rgb-key'])){
      colorToCluster[colors[i]['rgb-key']].push(colors[i]);
    }else{
      colorToCluster[colors[i]['rgb-key']] = [colors[i]];
    }

  // Merge clusters, starting with lowest distances
  var lastCluster;

  for (var i = 0; i < distances.length; i++) {
    var color1 = distances[i][0];
    var color2 = distances[i][1];

    var key1 = "";
    var key2 = "";
    if(color1 && color1.hasOwnProperty("rgb-key")){
      key1 = color1['rgb-key'];
    }
    if(color2 && color2.hasOwnProperty("rgb-key")){
      key2 = color2['rgb-key'];
    }
    var cluster1 = colorToCluster[key1];
    var cluster2 = colorToCluster[key2];
    if (!cluster1 || !cluster2 || cluster1 == cluster2){
      con++;
      continue;
    } else{
      nCon++;
    }

    // Make sure color1 is at the end of its cluster and
    // color2 at the beginning.
    if (color1['rgb-key'] != cluster1[cluster1.length - 1]['rgb-key'])
      cluster1.reverse();
    if (color2['rgb-key'] != cluster2[0]['rgb-key'])
      cluster2.reverse();

    // Merge cluster2 into cluster1
    var beforeSize = cluster1.length + cluster2.length;
    //Object.keys(obj).length
    cluster1.push.apply(cluster1, cluster2);
    var afterSize = cluster1.size;
    console.log("Difference: " + Math.abs(beforeSize - afterSize));
    delete colorToCluster[color1['rgb-key']];
    delete colorToCluster[color2['rgb-key']];
    colorToCluster[cluster1[0]['rgb-key']] = cluster1;
    colorToCluster[cluster1[cluster1.length - 1]['rgb-key']] = cluster1;
    lastCluster = cluster1;
  }

  // By now all colors should be in one cluster
  console.log("colors.size: " + colors.length + ", lastCluster.size: " + ( (lastCluster !== undefined) ? lastCluster.length : -1) );

  return lastCluster;
}


function colorDistance(color1, color2) {
  // This is actually the square of the distance but
  // this doesn't matter for sorting.
  var result = 0;
  for (var i = 0; i < color1.length; i++)
    result += (color1[i] - color2[i]) * (color1[i] - color2[i]);
  return result;
}

// Colour Names Case

/*
$(document).ready(function(){
	return;
  $('.capitalise-first-each-word').each(function(){

    var text = $(this).text().toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

  	$(this).text(text);


  });
});
*/


// Product Search Page

function compareBAProducts( a, b ) {
  if ( a.title.toLowerCase() < b.title.toLowerCase() ){
    return -1;
  }
  if ( a.title.toLowerCase() > b.title.toLowerCase() ){
    return 1;
  }
  return 0;
}

function searchObject(obj, queries){
  var returnValue = false;
  queriesLoop: 
  for(var k = 0; k < queries.length; k++){
    var query = queries[k];
    objLoop: 
    for (var key in obj) {
      var value = obj[key];

      if (typeof value === 'object' && !Array.isArray(value)) {
        returnValue = searchObject(value, queries);
        //console.log("obj: " + returnValue);
        continue objLoop;
      }
      if (Array.isArray(value)) {
        value = value.toString();
        //console.log("array: " + value);
      }
      if ((value + "").toLowerCase().includes(query.toLowerCase())) {
        //console.log('property=' + key + ' value=' + value);
        returnValue = obj;
        //console.log("includes: value[" + value + "], query[" + query + "]");
        break queriesLoop;
      }

    }
  }

  return returnValue;
}


function searchCollectionProducts (queries, collectionProducts) {
  var results = [];

  for(var i = 0; i < collectionProducts.length; i++){
    var obj = collectionProducts[i];
    var temp = searchObject(obj, queries);
    if(temp !== false){
      results.push(obj);
    }
  }
  console.log(results);
  return results;
}

$(document).ready(function(){

  /*
  $('.bc-sf-filter-option-block-type').each(function(){
  	var type = $(this);
    type.find('.bc-sf-filter-option-value').each(function(e){
  	var t = $(this);
    var sub_t = t.text().split(" - ");
    if(sub_t.length > 1){
      t.text(sub_t[0]);
      //console.log(sub_t[0]);
    }
  });

  });

  */

  $("body").on('submit', ".search-bar", function(e){
    //e.preventDefault();
    //console.log("HERE");
    var form = $('.search-bar').first();
    //console.log($(this).find("#search_filter_terms").val());
    //console.log(val);

    var val = $(this).find("#search_filter_terms").val() + " AND " + $(this).find("input[name='temp_q']").val();
    $(this).find("input[name='q']").val(val);
    return true;  	
  });


  $('.variant-option-selecter').on('click', function(){
    var _ = $(this);
    var selectedOption = _.data("option-title");
    var type = _.data("option-type");
    var vars = window.currentVariants;
    if(type == 'size'){
      var size = selectedOption;
      var colorsAvailable = [];
      for(var i = 0; i < vars.length; i++){
        var v = vars[i];
        if(v.option1 == size && v.available){
          colorsAvailable.push(v.option2);
        }
      }

      $('.variant-option-selecter[data-option-type="color"]').each(function(){
        if(colorsAvailable.indexOf($(this).data('option-title')) > -1){
          $(this).closest('.color-swatch').removeClass('color-swatch--disabled');
        } else{
          $(this).closest('.color-swatch').addClass('color-swatch--disabled');
        }
      });


    }else if(type == 'color'){
      var color = selectedOption;
      var sizesAvailable = [];
      for(var i = 0; i < vars.length; i++){
        var v = vars[i];
        if(v.option2 == color && v.available){
          sizesAvailable.push(v.option1);
        }
      }

      $('.variant-option-selecter[data-option-type="size"]').each(function(){
        if(sizesAvailable.indexOf($(this).data('option-title')) > -1){
          $(this).closest('.block-swatch').removeClass('block-swatch--disabled');
        } else{
          $(this).closest('.block-swatch').addClass('block-swatch--disabled');
        }
      });


    }

  });



});